<template>
  <div id="top">
    <ErrorMessage :status="portofolioApiData.status" :customMessage="portofolioApiData.customMessage" />

    <template v-if="portofolioApiData.status === 200">
      <PortofolioView
        :list="portofolioApiData.list"
        :careers="portofolioApiData.careers"
        :prefectures="portofolioApiData.prefectures"
        :career_types="portofolioApiData.career_types"
        :pfIcoDataURL="portofolioApiData.pfIcoDataURL"
        :pfBgDataURL="portofolioApiData.pfBgDataURL"
      ></PortofolioView>
    </template>
    <template v-else>
      <!-- 読み込み中 or エラー -->
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ErrorMessage from '@/components/ErrorMessage.vue'
import PortofolioView from '@/components/PortofolioView.vue'
import api from '@/api'
import { getErrorStatus } from '@/transformer/base'

export default {
  name: 'Top',
  components: {
    ErrorMessage,
    PortofolioView
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth.isLoggedIn
    })
  },
  data: function () {
    return {
      portofolioApiData: this.getEmptyPortofolioData()
    }
  },
  methods: {
    async updatePortofolioViewInfo() {
      await api.view
        .info(this.$route.params.token, document.referrer)
        .then((res) => {
          this.portofolioApiData = this.arrangeViewInfo(res)
        })
        .catch((e) => {
          const errors = getErrorStatus(e)
          this.portofolioApiData.status = errors.status
          this.portofolioApiData.customMessage = '表示できるデータがありません。URLを確認してください。'
          // 第三者向け画面なので、表示できないことだけを表示
          this.portofolioApiData.errors = errors.errors
        })
    },
    arrangeViewInfo(info) {
      const res = this.getEmptyPortofolioData()
      res.status = 200
      res.list = info.list[0]
      res.career_types = info.career_types
      res.pfBgDataURL = info.pfBgDataURL
      res.careers = info.careers
      res.pfIcoDataURL = info.pfIcoDataURL
      res.prefectures = info.prefectures.map((e) => {
        return e.name
      })
      return res
    },
    getEmptyPortofolioData() {
      return {
        list: {
          display_name: '',
          introduction: '',
          achievements: [],
          portofolio_id: null,
          profiles: {}
        },
        careers: [],
        prefectures: [],
        career_types: [],
        pfIcoDataURL: '',
        pfBgDataURL: '',
        status: 0,
        customMessage: ''
      }
    }
  },
  mounted: function () {
    this.updatePortofolioViewInfo()
  }
}
</script>
